<template>
	<div class="home-page" id="top">
		<div class="banner" >
			<Head position="absolute" mode="white" :isHaveLogin="true"></Head>
			<div class="swiper">
				<el-carousel ref="bannerCarousel" indicator-position="none" :interval="5000" trigger="click" height="100%" style="height: 100%" @change="bannerListChange">
					<el-carousel-item v-for="(item, index) in bannerList" :key="item.id">
						<div class="video-box mask">
							<!-- <img src="@/assets/tmp/040.png" alt="" /> -->
							<img :src="item.url" alt="" />
						</div>
						<div class="swiper-item w1260 " v-if="index == bannerListIndexDelay">
							<div class="content-block animate__animated animate__fadeInUp" >
								<div class="heading" v-html="item.title ? item.title.replace(/\\n/g, '<br>') : ''"></div>
								<div class="heading-line"></div>
								<div class="des">{{ item.content }}</div>
								<!-- 查看详情 -->
								<router-link tag="div" :to="{ name: 'about' }" class="check-btn-link">
									<el-button class="check-btn transparent" v-toggle-class="'transparent'" type="primary">
										<div class="btn-content">
											<div class="txt">查看详情</div>
											<svg-icon name="jiantou"></svg-icon>
											
										</div>
									</el-button>
								</router-link>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
				
				<!-- 轮播图指示器 -->
				<div class="lines w1260" v-if="bannerList.length > 1">
					<div class="line" :class="{ active: i - 1 == bannerListIndex }" v-for="i in bannerList.length" @click="changeBannerActive(i - 1)"></div>
				</div>
				<!-- 统计数据 -->
				<div class="statistics w1260" v-if="false">
					<div class="column">
						<div class="statistics-item">
							<div class="value">
								<div class="num">
									<countTo :startVal="0" :endVal="topStatistics.certCompanyNum || 0" :duration="3000"></countTo>
								</div>
								<div class="unit">家</div>
							</div>
							<div class="label">企业用户</div>
						</div>
						<div class="statistics-item">
							<div class="value">
								<div class="num">
									<countTo :startVal="0" :endVal="topStatistics.companyNum || 0" :duration="3000"></countTo>
								</div>
								<div class="unit">批</div>
							</div>
							<div class="label">集装箱产品碳标签</div>
						</div>
					</div>
					<div class="column">
						<div class="statistics-item">
							<div class="value">
								<div class="num">
									<countTo :startVal="0" :endVal="topStatistics.lcaPcrProductNum || 0" :duration="3000"></countTo>
								</div>
								<div class="unit">份</div>
							</div>
							<div class="label">产品碳足迹报告</div>
						</div>
						<div class="statistics-item">
							<div class="value">
								<div class="num">
									<countTo :startVal="0" :endVal="topStatistics.certNum || 0" :duration="3000"></countTo>
								</div>
								<div class="unit">份</div>
							</div>
							<div class="label">绿色集装箱产品证书</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="page-content">
			<!-- 四大服务 -->
			<div class="animate__animated animate__fadeInUp"  style="animation-duration: 1500ms" >
				<div class="sidayoushi">
					<div class="list">
						<div class="item" v-for="(item,index) in webInfo.sidafuwu" >
							<div class="card">
								<div class="icon">
									<svg-icon :name="item.icon"></svg-icon>
								</div>
								<div class="title">{{item.title}}</div>
								<div class="des">{{item.des}}</div>
								<div class="more">
									<div class="text">了解更多</div>
									<svg-icon name="jiantou4"></svg-icon>
								</div>
							</div>
							<router-link tag="div" class="active-card" :to="{ name: item.name }">
								<div class="icon">
									<svg-icon :name="item.iconActive"></svg-icon>
								</div>
								<div class="title">{{item.title}}</div>
								<div class="des">{{item.des}}</div>
								<div class="more">
									<div class="text">了解更多</div>
									<svg-icon name="jiantou4"></svg-icon>
								</div>
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<!-- 平台优势 -->
			<div class="pingtaiyoushi">
				<div class="pingtaiyoushi-container w1360">
					<div class="header">
						<div class="title">平台优势</div>
						<div class="des">为绿色未来助力</div>
					</div>
					<div class="body">
						<div class="list">
							<div class="item-ani wow animate__animated animate__fadeInUp" :style="`animation-duration: ${1000 + 200 * index}ms`" v-for="(item,index) in webInfo.pingtaiyoushi" @click="youshiClick(item)">
								<router-link tag="div" class="item scale-img" to="" >
									<div class="cover over-hidden">
										<img class="img" :src="item.cover" alt="" />
									</div>
									<div class="content">
										<div class="title">{{item.title}}</div>
										<div class="des">{{item.des}}</div>
										<div class="more">
											<div class="text">了解更多</div>
											<svg-icon name="jiantou4"></svg-icon>
										</div>
									</div>
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 技术文件 -->
			<div class="jishuwenjian">
				<div class="jishuwenjian-container w1360">
					<div class="header">
						<div class="title">技术文件</div>
						<div class="des">规范制定与实施</div>
						<router-link tag="div" :to="{ name: 'technology' }">
							<el-button class="all-btn" type="primary">全部文件</el-button>
						</router-link>
					</div>
					<div class="body">
						<div class="list">
							<div class="item-ani wow animate__animated animate__fadeInUp" :style="`animation-duration: ${1000 + 200 * index}ms`" v-for="(item, index) in pcrList" :key="index">
								<div class="item" @click="jsbzClick(item)">
									<div class="title ellipsis-1">{{ item.groupStandardName }}</div>
									<div class="lines">
										<div class="green"></div>
										<div class="orange"></div>
									</div>
									<div class="des ellipsis-3">
										{{ item.description }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 新闻资讯 -->
			<div class="xinwenzixun">
				<div class="xinwenzixun-container w1360">
					<div class="header">
						<div class="title">绿色资讯</div>
						<div class="des">数智减排链全球</div>
						<router-link tag="div" :to="{ name: 'information', query: { type: 1 } }">
							<el-button class="all-btn" type="primary">全部资讯</el-button>
						</router-link>
					</div>
					<div class="body">
						<div class="list">
							<div class="item-ani wow animate__animated animate__fadeInUp" :style="`animation-duration: ${1000 + 200 * index}ms`" v-for="(item, index) in informationList" :key="index">
								<router-link tag="div" class="list-item-link" :to="{ name: 'informationDetails', query: { id: item.id, type: 2 , from: 1 }  }">
									<div class="list-item">
										<div class="item-header">
											<div class="tag">通知公告</div>
											<!-- <div class="date">{{ $moment(item.createTime).format('YYYY-MM-DD') }}</div> -->
										</div>
										<div class="title ellipsis-2">{{ item.title }}</div>
										<svg-icon name="arrow4"></svg-icon>
									</div>
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 获证企业 -->
			<div class="huozhengqiye">
				<div class="huozhengqiye-container w1360">
					<div class="header">
						<div class="title">合作企业</div>
						<div class="des">碳索共赢护地球</div>
					</div>
					<div class="body">
						<vue-seamless-scroll :data="companyList" :class-option="classOption" class="warp">
							<div class="list">
								<div v-for="(item, index) in companyList" :key="index" @click="companyClick(item)">
									<div :title="item.cnName" class="list-item scale-img">
										<img class="img" :src="item.url" alt="" />
									</div>
								</div>
							</div>
						</vue-seamless-scroll>
					</div>
				</div>
			</div>
			<Foot></Foot>
		</div>
	</div>
</template>

<script>
	import { webInfo } from '@/common/data.js';
import Head from '@/layout/Head/Head.vue';
import Foot from '@/layout/Foot/Foot.vue';
import { PcrList, ProductDictionary, InformationListForHome, CompanyListByCooperation, TopStatistics, BannerList, SingleSignOnUrl } from '@/common/api.js';
import { chunkArray } from '@/common/utils.js';
import countTo from 'vue-count-to';
import { homeBannerTabs, companyIcons } from '@/common/data.js';
import { WOW } from 'wowjs';
export default {
	name: 'home',
	components: { Head, Foot, countTo },
	data() {
		return {
			// 网站信息
			webInfo: webInfo,
			// 顶部轮播图
			bannerList: [],
			// 顶部数据统计
			topStatistics: {},
			// 无缝滚动配置
			classOption: {
				limitMoveNum: 5,
				direction: 2
			},
			// 资讯列表
			informationList: [{},{},{},{},{},{},{},{},],
			// 企业列表
			companyList: [],
			//
			homeBannerTabs: homeBannerTabs,
			// 顶部轮播图的索引
			bannerListIndex: 0,
			bannerListIndexDelay: 0,
			// 视频的key
			videoKey: 0,
			//
			pcrList: [{},{},{},{},{},{},]
		};
	},
	created() {
		this.getBannerList();
		this.getTopStatistics();
		this.getPcrList();
		this.getInformationListForHome();
		this.getCompanyListByCooperation();
	},
	activated() {
		// 解决页面缓存后视频不播放问题
		this.videoKey++;
	},
	mounted() {
		// 禁止当鼠标在轮播图上时，不自动轮播
		this.$refs.bannerCarousel.handleMouseEnter = () => {};
		this.$nextTick(() => {
			new WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 100,
				mobile: true,
				live: true,
				// callback: function (c) {
				//     console.log(c, 'sss')
				// },
				scrollContainer: null,
				resetAnimation: true
			}).init();
		});
	},
	methods: {
		// 点击获证企业
		companyClick(item) {
			if (item.link){
				window.open(item.link, '_blank');
			}
		},
		// 点击优势
		youshiClick(item) {
			this.$router.push({name: item.id})
		},
		// 顶部轮播图切换
		bannerListChange(index) {
			this.bannerListIndex = index;
			setTimeout(() => {
				this.bannerListIndexDelay = index;
			},800)
		},
		//获取顶部轮播图
		getBannerList() {
			BannerList().then((res) => {
				this.bannerList = res.data;
			});
		},
		//获取顶部数据统计
		getTopStatistics() {
			TopStatistics().then((res) => {
				this.topStatistics = res.data;

				// this.topStatistics.certCompanyNum = Number(res.data.certCompanyNum)
				// this.topStatistics.companyNum = Number(res.data.companyNum)
				// this.topStatistics.lcaPcrProductNum = Number(res.data.lcaPcrProductNum)
				// this.topStatistics.certNum = Number(res.data.certNum)
			});
		},
		//获取pcr列表
		getPcrList() {
			let data = {
				pageNum: 1,
				pageSize: 6,
				keyWord: '',
				startTime: '',
				endTime: '',
				type: ''
			};
			PcrList(data).then((res) => {
				this.pcrList = res.data;
			});
		},
		// 打开技术标准链接
		jsbzClick(item) {
			if (item.groupStandard){
				window.open(item.groupStandard, '_blank');
			} else {
				let certificationOssPath = item.certificationOssPath ? JSON.parse(item.certificationOssPath) : [];
				if (certificationOssPath && certificationOssPath.length && certificationOssPath[0].url) {
					this.previewPdfAsBlob(certificationOssPath[0].url)
				} else {
					return
				}
			}
		},
		// 获取PDF为Blob，然后创建Object URL
		async previewPdfAsBlob(pdfUrl) {
		
			try {
				// 使用fetch获取
				const response = await fetch(pdfUrl, {
				headers: {
					'Accept': 'application/pdf'
				}
				})
				
				if (response.ok) {
				const blob = await response.blob()
				
				// 创建Object URL
				const blobUrl = URL.createObjectURL(blob)
				
				// 方法1: 使用iframe
				// const iframe = document.createElement('iframe')
				// iframe.src = blobUrl
				// iframe.width = '100%'
				// iframe.height = '600px'
				// document.getElementById('preview-container').appendChild(iframe)
				
				// 方法2: 使用window.open
				window.open(blobUrl, '_blank')
				
				// 清理（在组件销毁时）
				// URL.revokeObjectURL(blobUrl)
				}
			} catch (error) {
				console.error('加载失败:', error)
			}
		},
		//获取企业列表
		getCompanyListByCooperation() {
			CompanyListByCooperation().then((res) => {
				// this.companyList = chunkArray([...companyIcons, ...companyIcons], 2);
				// return;
				this.companyList = res.data;
				// this.companyList = chunkArray(res.data, 2);
			});
		},
		// 获取资讯列表
		getInformationListForHome(index) {
			let data = {
				pageNum: 1,
				pageSize: 8,
				releaseState: 1,
				title: '',
				itemCode: ''
			};
			InformationListForHome(data).then((res) => {
				this.informationList = res.data;
			});
		},
		// 切换banner
		changeBannerActive(index) {
			console.log('index: ', index);
			this.$refs.bannerCarousel.setActiveItem(index);
		}
	}
};
</script>

<style lang="scss" scoped>
.home-page {
	position: relative;
	// padding-top: calc(570px);
	.banner {
		position: sticky;
		z-index: 1;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		// background-image: url('~@/assets/tmp/001.png');
		background-size: cover;
		// margin-top: -$head-height;
		.swiper {
			height: 100%;
			position: relative;
			::v-deep {
				.el-carousel {
					.el-carousel__container {
						.el-carousel__item {
							// position: relative;
						}
					}
				}
			}

			.video-box {
				z-index: -1;
				position: absolute;
				top: 0;
				right: 0;
				width: 100%;
				height: 100vh;
				video {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
			.swiper-item {
				position: relative;
				.content-block {
					position: absolute;
					top: 13vh;
					// top: 20.68vh;
					left: 0;
					
					.heading {
						font-family: PingFangSC, PingFang SC;
						// font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
						font-weight: bold;
						font-size: 40px;
						color: #ffffff;
						letter-spacing: 3px;
						line-height: 60px;
						height: 120px;
						white-space: pre-wrap;
					}
					.heading-line {
						margin-top: 16px;
						width: 465px;
						height: 1px;
						background-color: rgba(255, 255, 255, 0.12);
					}
					.des {
						margin-top: 16px;
						width: 465px;
						min-height: 42px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: #ffffff;
						line-height: 21px;
						text-align: justify;
					}
					// 查看详情
					.check-btn-link {
						margin-top: 20px;
						.check-btn {
							width: 93px;
							height: 31px;
							display: flex;
							justify-content: center;
							align-items: center;
							padding: 0;
							border-radius: 0;
							&.transparent {
								color: #fff;
								background-color: rgba($primary, 0.5);
								border-color: rgba($primary, 0.5);
							}
							.btn-content {
								display: flex;
								align-items: center;
								.txt {
									font-size: 12px;
								}
								.svg-jiantou {
									width: 17px;
									height: 13px;
									margin-left: 9px;
									margin-bottom: 1px;
								}
							}
						}
					}
				}
			}
			// 轮播图指示器
			.lines {
				z-index: 9;
				position: absolute;
				top: calc(46vh + 31px + 30px);
				// top: calc(54vh + 31px + 30px);
				display: flex;
				.line {
					width: 48px;
					height: 3px;
					background: rgba(#ffffff, 0.2);
					cursor: pointer;
					margin-right: 5px;
					&.active {
						background: rgba(#ffffff, 0.8);
					}
				}
			}
			// 统计数据
			.statistics {
				z-index: 9;
				position: absolute;
				top: 18vh;
				// top: 26.26vh;
				display: flex;
				justify-content: flex-end;
				pointer-events: none;
				padding-right: 150px;
				box-sizing: border-box;
				.column {
					pointer-events: auto;
					display: flex;
					flex-direction: column;
					.statistics-item {
						padding: 0 40px 30px;
						display: flex;
						flex-direction: column;
						align-items: center;
						.value {
							display: flex;
							justify-content: flex-end;
							align-items: baseline;
							.num {
								font-family: SourceHanSerifCN, SourceHanSerifCN;
								font-weight: bold;
								font-size: 42px;
								color: #ffffff;
								span {
									font-family: SourceHanSerifCN, SourceHanSerifCN;
									font-weight: bold;
									font-size: 42px;
									color: #ffffff;
								}
							}
							.unit {
								font-family: SourceHanSerifCN, SourceHanSerifCN;
								font-size: 14px;
								color: #ffffff;
								margin-left: 10px;
							}
						}
						.label {
							margin-top: 10px;
							font-family: SourceHanSerifCN, SourceHanSerifCN;
							// font-weight: bold;
							font-size: 14px;
							color: #ffffff;
							line-height: 15px;
							text-align: center;
						}
					}
				}
			}
			
		}
	}
	.page-content {
		margin-top: -270px;
		position: relative;
		z-index: 9;
		// background-color: #ffffff;
	}
	// 
	.sidayoushi {
		.list {
			display: flex;
			overflow: hidden;
			height: 270px;
			.item {
				width: 25%;
				display: flex;
				transition: all 0.3s ease;
				&:nth-child(odd) {
					.card {
						background: #ffffff;
					}
				}
				&:nth-child(even) {
					.card {
						background: #f6f6f6;
					}
				}
				&:hover {
					width: 33%;
					flex-shrink: 0;
					.card {
						display: none;
					}
					.active-card {
						display: flex;
					}
				}
				.card {
					width: 100%;
					display: flex;
					flex-direction: column;
					align-items: center;
					// padding: 0 35px;
					padding-bottom: 25px;
					box-sizing: border-box;
					cursor: pointer;
					.icon {
						height: 92px;
						display: flex;
						flex-direction: column;
						align-items: center;
						// margin-bottom: 10px;
						.svg-bar {
							margin-top: 42px;
							width: 31px;
							height: 31px;
						}
						.svg-renzheng {
							margin-top: 42px;
							width: 33px;
							height: 33px;
						}
						.svg-yun {
							margin-top: 40px;
							width: 33px;
							height: 35px;
						}
						.svg-shuye3 {
							margin-top: 42px;
							width: 31px;
							height: 33px;
						}
					}
					.title {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 18px;
						color: #000000;
						line-height: 25px;
					}
					.des {
						width: 264px;
						margin-top: 16px;
						min-height: 55px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #9f9f9f;
						line-height: 17px;
						text-align: justify;
						text-align-last: center;
					}
					.more {
						margin-top: 10px;
						padding: 15px;
						display: flex;
						align-items: center;
						.text {
							margin-right: 4px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 12px;
							color: #29965c;
							line-height: 17px;
						}
						.svg-jiantou4 {
							width: 12px;
							height: 9px;
							stroke: #29965c;
						}
					}
				}
				.active-card {
					width: 100%;
					display: none;
					background: #29965c;
					flex-direction: column;
					padding-left: 89px;
					// padding-right: 54px;
					padding-bottom: 25px;
					box-sizing: border-box;
					position: relative;
					cursor: pointer;
					.icon {
						position: absolute;
						top: 0;
						right: 0;
						padding-top: 30px;
						padding-right: 30px;
						.svg-bar2 {
							width: 49px;
							height: 50px;
						}
						.svg-renzheng2 {
							width: 52px;
							height: 52px;
						}
						.svg-yun2 {
							width: 55px;
							height: 59px;
						}
						.svg-shuye4 {
							width: 49px;
							height: 53px;
						}
					}
					.title {
						margin-top: 69px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 18px;
						color: #f1fff7;
						line-height: 23px;
					}
					.des {
						margin-top: 15px;
						width: 331px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: rgba(#ffffff, 0.83);
						line-height: 18px;
					}
					.more {
						margin-top: 18px;
						padding: 15px 15px 15px 0;
						display: flex;
						align-items: center;
						.text {
							margin-right: 4px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 12px;
							color: #ffffff;
							line-height: 17px;
						}
						.svg-jiantou4 {
							width: 12px;
							height: 9px;
							stroke: #ffffff;
						}
					}
				}
			}
		}
	}
	// 平台优势
	.pingtaiyoushi {
		background-color: #ffffff;
		.pingtaiyoushi-container {
			padding: 44px 0 30px;
			.header {
				padding: 0 0 48px;
				.title {
					font-weight: bold;
					font-size: 40px;
					color: #000000;
					line-height: 56px;
				}
				.des {
					font-weight: bold;
					font-size: 40px;
					color: #000000;
					line-height: 56px;
				}
			}
			.body {
				.list {
					$list-item-gap: calc((100% - (324px * 4)) / 3);
					display: flex;
					.item-ani {
						margin-left: $list-item-gap;
						&:nth-child(4n + 1) {
							margin-left: 0;
						}
						.item {
							// margin-left: $list-item-gap;
							width: 324px;
							height: 346px;
							display: flex;
							flex-direction: column;
							cursor: pointer;
							
							&:hover {
								.content {
									.title {
										color: #29965c;
									}
									.more {
										.text {
											display: block;
										}
									}
								}
							}
							.cover {
								width: 100%;
								height: 175px;
								img {
									width: 100%;
									height: 100%;
									object-fit: cover;
								}
							}
							.content {
								flex: 1;
								padding-top: 22px;
								padding-left: 18px;
								padding-right: 18px;
								padding-bottom: 7px;
								border: 1px solid #e7e7e7;
								display: flex;
								flex-direction: column;
								.title {
									font-family: PingFangSC, PingFang SC;
									font-weight: 400;
									font-size: 18px;
									color: #000000;
									line-height: 25px;
								}
								.des {
									flex: 1;
									margin-top: 10px;
									font-family: PingFangSC, PingFang SC;
									font-weight: 400;
									font-size: 12px;
									color: #9f9f9f;
									line-height: 17px;
								}
								.more {
									margin-top: 10px;
									padding: 15px 15px 15px 0;
									display: flex;
									align-items: center;
									cursor: pointer;
									.text {
										display: none;
										margin-right: 30px;
										font-family: PingFangSC, PingFang SC;
										font-weight: 400;
										font-size: 12px;
										color: #29965c;
										line-height: 17px;
									}
									.svg-jiantou4 {
										width: 12px;
										height: 9px;
										stroke: #29965c;
									}
								}
							}
						}
					}
				}
			}
		}
	}
	// 技术文件
	.jishuwenjian {
		background-color: #ffffff;
		.jishuwenjian-container {
			padding: 30px 0 30px;
			.header {
				padding: 0 0 23px;
				position: relative;
				.title {
					font-weight: bold;
					font-size: 40px;
					color: #000000;
					line-height: 56px;
				}
				.des {
					font-weight: bold;
					font-size: 40px;
					color: #000000;
					line-height: 56px;
				}
				.all-btn {
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 0;
					font-size: 14px;
					line-height: 20px;
					width: 111px;
					height: 51px;
					border-radius: 0;
					position: absolute;
					top: 50%;
					right: 0;
					transform: translateY(-50%);
				}
			}
			.body {
				.list {
					$list-item-gap: calc((100% - (410px * 3)) / 2);
					margin-top: 4px;
					display: flex;
					flex-wrap: wrap;
					.item-ani {
						margin-top: 30px;
						margin-left: $list-item-gap;
						&:nth-child(3n + 1) {
							margin-left: 0;
						}
						.item {
							width: 410px;
							height: 166px;
							background: #ffffff;
							box-shadow: 0px 2px 15px 0px rgba(203, 214, 252, 0.43);
							padding-top: 21px;
							padding-left: 27px;
							padding-right: 27px;
							padding-bottom: 21px;
							box-sizing: border-box;
							display: flex;
							flex-direction: column;
							cursor: pointer;
							transition: all 0.3s ease;
							&:hover {
								background: $primary;
								.title {
									color: #FFFFFF;
								}
								.lines {
									.green {
										width: 104px;
										background: #FFFFFF;
									}
									.orange {
										width: 58px;
									}
								}
								.des {
									color: #FFFFFF;
								}
							}
							
							.title {
								transition: inherit;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								font-size: 18px;
								color: #000000;
								line-height: 25px;
							}
							.lines {
								margin-top: 17px;
								display: flex;
								.green {
									width: 27px;
									height: 3px;
									background: $primary;
									transition: all 0.3s ease;
								}
								.orange {
									width: 15px;
									height: 3px;
									background: #ffaeae;
									transition: all 0.3s ease;
								}
							}
							.des {
								transition: inherit;
								margin-top: 13px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								font-size: 12px;
								color: rgba(#232536, 0.6);
								line-height: 22px;
								text-align: justify;
							}
						}
					}
				}
			}
		}
	}
	// 新闻资讯
	.xinwenzixun {
		background-color: #ffffff;
		.xinwenzixun-container {
			padding: 30px 0 30px;
			.header {
				padding-bottom: 48px;
				display: flex;
				flex-direction: column;
				position: relative;
				.title {
					font-weight: bold;
					font-size: 40px;
					color: #000000;
					line-height: 56px;
				}
				.des {
					font-weight: bold;
					font-size: 40px;
					color: #000000;
					line-height: 56px;
				}
				.all-btn {
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 0;
					font-size: 14px;
					line-height: 20px;
					width: 111px;
					height: 51px;
					border-radius: 0;
					position: absolute;
					top: 50%;
					right: 0;
					transform: translateY(-50%);
				}
			}
			.body {
				.list {
					$list-item-gap: calc((100% - (324px * 4)) / 3);
					display: flex;
					flex-wrap: wrap;
					.item-ani {
						margin-left: $list-item-gap;
						margin-top: 20px;
						&:nth-child(4n + 1) {
							margin-left: 0;
						}
						.list-item-link {
							.list-item {
								display: flex;
								flex-direction: column;
								cursor: pointer;
								background: #ffffff;
								border: 1px solid #e7e7e7;
								padding-top: 27px;
								padding-left: 18px;
								padding-right: 14px;
								// padding-bottom: 10px;
								box-sizing: border-box;
								width: 324px;
								height: 186px;
								background: #ffffff;
								border: 1px solid #e7e7e7;
								transition: all 0.5s ease;
								&:hover {
									padding-top: 17px;
									box-shadow: 0px 6px 11px 0px rgba(0, 0, 0, 0.1);
									border: 1px solid #29965c;
									// .title {
									// 	margin-top: 22px;
									// }
									.svg-arrow4 {
										display: block;
									}
								}
								.item-header {
									display: flex;
									align-items: center;
									.tag {
										padding: 0 7px;
										height: 25px;
										background: #29965c;
										font-family: PingFangSC, PingFang SC;
										font-weight: 400;
										font-size: 14px;
										color: #ffffff;
										line-height: 25px;
									}
									.date {
										margin-left: auto;
										font-family: PingFangSC, PingFang SC;
										font-weight: 400;
										font-size: 12px;
										color: #9f9f9f;
										line-height: 22px;
									}
								}
								.title {
									transition: all 0.5s ease;
									margin-top: 32px;
									font-family: PingFangSC, PingFang SC;
									font-weight: 400;
									font-size: 18px;
									color: #000000;
									line-height: 25px;
								}
								.svg-arrow4 {
									transition: all 0.5s ease;
									display: none;
									margin-top: 15px;
									width: 25px;
									height: 25px;
								}
							}
						}
					}
				}
			}
		}
	}
	// 获证企业
	.huozhengqiye {
		background-color: #ffffff;
		.huozhengqiye-container {
			padding: 30px 0 60px;
			.header {
				margin: 0 0 10px;
				.title {
					font-weight: bold;
					font-size: 40px;
					color: #000000;
					line-height: 56px;
				}
				.des {
					font-weight: bold;
					font-size: 40px;
					color: #000000;
					line-height: 56px;
					
				}
			}
			.body {
				.warp {
					height: calc((96px * 1) + (50px * 1));
					overflow: hidden;
				}
				.list {
					display: flex;
					height: calc((96px * 1) + (50px * 1));
					.list-item {
						width: 232px;
						height: 96px;
						background: #ffffff;
						border: 1px solid #f2f2f2;
						box-sizing: border-box;
						display: flex;
						justify-content: center;
						align-items: center;
						padding: 0 20px;
						margin-top: 50px;
						margin-right: 50px;
						cursor: pointer;
						img {
							width: 100%;
							height: 100%;
							object-fit: contain;
						}
					}
				}
			}
		}
	}
}
</style>
